<div class="component rounded-pill text-light d-inline-block">{{title}}</div>
